/* eslint-disable no-param-reassign */

export default (action, storeTarget, sender) => {
    if (!storeTarget) {
        const msg = 'actionTarget called without a storeTarget'
        if (console && console.warn) {
            console.warn(msg, action, sender)
        }
        // TODO YAM-393
        // throw new Error(msg)
    }
    if (!action.meta) {
        action = {
            ...action,
            meta: {
                storeTarget
            }
        }
    } else {
        action = {
            ...action,
            meta: {
                storeTarget,
                ...action.meta
            }
        }
    }
    if (!action.meta.sender) {
        action.meta.sender = sender
    }
    return action
}
